export default __webpack_public_path__ + "static/media/ert_portada.9d649d32.png";